import { Component, EventEmitter, Output, ViewChild, ElementRef } from '@angular/core';

@Component({
  selector: 'app-upload-file',
  templateUrl: './upload-file.component.html',
  styleUrls: ['./upload-file.component.css']
})
export class UploadFileComponent {

  @Output() addFile = new EventEmitter<File>();
  @Output() fileCleared = new EventEmitter<void>(); // ✅ para notificar limpieza al padre
  @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>; // ✅ referencia segura

  archivoSeleccionado: File | null = null;
  archivoConfirmado: boolean = false;

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.archivoSeleccionado = input.files[0];
      this.archivoConfirmado = false;
    }
  }

  eliminarArchivo(): void {
    this.archivoSeleccionado = null;
    this.archivoConfirmado = false;
    if (this.fileInput) {
      this.fileInput.nativeElement.value = ''; // ✅ limpia el input correctamente
    }
    this.fileCleared.emit(); // notifica al padre
  }

  crearArchivo(): void {
    if (!this.archivoSeleccionado) return;
    this.addFile.emit(this.archivoSeleccionado);
    this.archivoConfirmado = true;
  }
}
